import { css } from 'styled-components'
import { withPrefix } from 'gatsby'

// const testEnv = process.env.NODE_ENV === 'test'
// const MissMagnoliaEot = testEnv ? '' : withPrefix('/fonts/missMagnolia/MissMagnolia-Regular.eot')
// const MissMagnoliawoff = testEnv ? '' : withPrefix('/fonts/missMagnolia/MissMagnolia-Regular.woff')
// const MissMagnoliaWoff2 = testEnv ? '' : withPrefix('/fonts/missMagnolia/MissMagnolia-Regular.woff2')

// export const SentinelFamily = `font-family: "Sentinel A", "Sentinel B", serif;`
export const MissMagnolia = `font-family: "miss-magnolia", serif;`

interface ISentinel {
  black: string,
  italic: string
  reg: string,
  semiboldItalic: string
}

export const Sentinel: ISentinel = {
  black: `font-family: "Sentinel Black", serif;`,
  italic: `font-family: "Sentinel MediumItal", serif; font-style: italic;`,
  semiboldItalic: `
  font-family: "Sentinel SemiboldItal", serif; 
  font-style: italic;
  -webkit-font-smoothing: auto;
  font-weight: 200;
  `,
  reg: `font-family: "Sentinel", serif;`,
}

// export default css`
//     @font-face {
//       font-family: 'miss-magnolia';
//       src: url(${MissMagnoliaEot}),
//       url(${MissMagnoliawoff}) format("woff2"),
//       url(${MissMagnoliaWoff2}) format("woff");
//       font-weight: normal;
//       font-style: normal
//   }
// `

